// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import { CheckItemView } from 'app/scripts/views/checklist/CheckItemView';
import CollectionView from 'app/scripts/views/internal/collection-view';

class CheckItemListView extends CollectionView {
  static initClass() {
    this.prototype.viewType = CheckItemView;
  }
}

CheckItemListView.initClass();
export { CheckItemListView };
